// extracted by mini-css-extract-plugin
export default {"wrap":"CH-z","subtitle":"DH-z","contentWrap":"EH-z","imgWrap":"FH-z","heading":"GH-z","copy":"HH-z"};